import styled from '../../styles/styled';
import { MIN_WIDTH } from '../constants';
import { getPointerPosition, getPointerShape } from './helpers';
import RawDismissIcon from '../../Icons/circle-x-duotone';
export const Root = styled.div `
  position: relative;
  min-width: ${MIN_WIDTH}px;
  width: ${({ width }) => (width && `${width}px`) || 'max-content'};
  background-color: ${({ theme }) => theme.colors.surfaceInverse30};
  border-radius: ${({ theme }) => theme.borders.radius30};
  padding: ${({ theme }) => theme.spacing.spacing40};
  overflow: visible;
`;
export const Pointer = styled.div `
  display: none;
  @supports (clip-path: inset(50%)) {
    height: 12px;
    width: 12px;
    background-color: inherit;
    display: ${({ pointer }) => (pointer ? 'block' : 'none')};
    position: absolute;
    ${(props) => {
    const { theme, pointer, top, left, } = props;
    const position = getPointerPosition({ pointer, top, left });
    const shape = getPointerShape({ theme, pointer });
    return {
        ...shape,
        ...position,
    };
}}
  }
`;
export const Container = styled.div `
  display: flex;
  align-items: center;
  overflow: hidden;
`;
export const IconContainer = styled.i `
  cursor: pointer;
  margin-left: ${({ theme }) => theme.spacing.spacing20};
  display: inline-flex;
`;
export const DismissIcon = styled(RawDismissIcon) `
  path {
    fill: ${({ theme }) => theme.colors.textInversePrimary};
  }
  circle {
    fill: ${({ theme }) => theme.colors.textInverseOutline};
  }
`;
export const TextContent = styled.div `
  flex: auto;
  ${({ theme }) => theme.typography.bodySmall};
  color: ${({ theme }) => theme.colors.textInversePrimary};
`;
